export default __webpack_public_path__ + "static/media/up-small.d28c34fd.svg";